module Meevo.Components.Controls {
    declare let d3: any;

    class MeevoGoalsFiveStarRatingComponent implements angular.IComponentController {

        static $inject = ['$scope'];
        public goalDecimal: number;
        public actualDecimal: number;
        public chartClass: string;
        public parent: any;
        public goal: number;
        public actual: number;
        public stars: any[];
        constructor(private $scope: ng.IScope) { }


        $onInit = () => {

            this.goalDecimal = this.goal;
            this.actualDecimal = this.actual;

            let ratingWholeNumber = Math.floor(this.parent.actual) || 0;
            let remainder = this.parent.actual - ratingWholeNumber;
            let unfilledWholeNumber = 5 - Math.round(this.parent.actual);

            for (var i = 0; i < ratingWholeNumber; i++) {
                this.stars.push({ type: 'whole' });
            }

            if (remainder >= 0.75) {
                this.stars.push({ type: 'three-quarter' });
            } else if (remainder >= 0.5) {
                this.stars.push({ type: 'half' });
            } else if (remainder >= 0.25) {
                this.stars.push({ type: 'quarter' });
            }

            for (var i = 0; i < unfilledWholeNumber; i++) {
                this.stars.push({ type: 'unfilled' });
            }

            setTimeout(() => {
                var starsToFadeIn = document.querySelectorAll('.star.no-opacity');
                for (var i = 0; i < starsToFadeIn.length; i++) {
                    starsToFadeIn[i].className += ' show-opacity';
                }
            }, 250)

        }




    }


    angular.module('meevo.components.controls')
        .component('meevoGoalsFiveStarRatingComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/charts/goalsFiveStarRating/goalsFiveStarRating.template.html',
            controller: MeevoGoalsFiveStarRatingComponent,
            controllerAs: 'vm',
            bindings: {
                chartClass: '@',
                goal: '<',
                actual: '<',
                mapFn: '=',
                stars: '<'
            },
            require: {
                parent: '^^meevoGoalsTileComponent'
            }
        });
}